var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingRoundRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 61,
    viewBox: "0 0 65 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 59C48.0163 59 61 46.0163 61 30C61 13.9837 48.0163 1 32 1C15.9837 1 3 13.9837 3 30C3 46.0163 15.9837 59 32 59ZM32 49C42.4934 49 51 40.4934 51 30C51 19.5066 42.4934 11 32 11C21.5066 11 13 19.5066 13 30C13 40.4934 21.5066 49 32 49Z",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 30L44 27.1132L44 32.8868L49 30ZM15 30L20 32.8867L20 27.1132L15 30ZM44.5 29.5L19.5 29.5L19.5 30.5L44.5 30.5L44.5 29.5Z",
    fill: "#F38D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingRoundRing);
export default __webpack_public_path__ + "static/media/jobconfig-binding-roundRing.6b2d719c8b1e198a19a5b1d22e173ec4.svg";
export { ForwardRef as ReactComponent };